// A legacy action URL that is only a dialog in the New UI (/admin/candidates/1/delete) redirects
// to its record page with `?dialog=delete`. The page opens that dialog once, when the user may
// use it; its remountKey covers the search, so the request is read at mount.
export const DIALOG_PARAM = 'dialog';

export type RequestedDialog = 'delete' | 'move' | 'clone' | 'send-email';

export const withRequestedDialog = (href: string, dialog: RequestedDialog): string =>
  `${href}${href.includes('?') ? '&' : '?'}${DIALOG_PARAM}=${dialog}`;

export const requestedDialog = (search: string): string | null =>
  new URLSearchParams(search).get(DIALOG_PARAM);
